export default __webpack_public_path__ + "static/media/LAS0170.34I-30558_-20945_0.a88b1c0f.jpg";